import React from 'react';

type PhoneInterviewInfoProps = {
  researcherWillCall: boolean;
};

export function PhoneInterviewInfo({
  researcherWillCall,
}: PhoneInterviewInfoProps) {
  const callDetails = researcherWillCall
    ? 'Researcher will call participant.'
    : 'Participant will dial in.';

  return (
    <dl>
      <dt>Call details</dt>
      <dd>{callDetails}</dd>
    </dl>
  );
}
